import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { fmtUtc } from "@/lib/trading";

const LEVEL = { info: "text-slate-300", warning: "text-amber-300" };

export const LiveTestPanel = ({ accountId }) => {
  const [data, setData] = useState(null);
  const [paste, setPaste] = useState("");
  const load = useCallback(() => api.get(`/accounts/${accountId}/sync-logs`).then((r) => setData(r.data)).catch(() => {}), [accountId]);

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [load]);

  const save = async () => {
    try { await api.post(`/accounts/${accountId}/sync-logs`, { text: paste }); setPaste(""); toast.success("Experts tab log shared"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  const connected = !!data?.last_ping_at;
  return (
    <div className="space-y-3 border-t border-slate-800 pt-4" data-testid="live-test-panel">
      <div className="flex items-center justify-between">
        <p className="text-xs font-mono uppercase tracking-wider text-slate-500">Live test · EA log</p>
        <span className={`text-xs font-mono ${connected ? "text-emerald-400" : "text-slate-500 animate-pulse"}`} data-testid="live-test-status">
          {connected ? `● EA connected ${fmtUtc(data.last_ping_at)} UTC` : "○ Waiting for EA to start…"}
        </span>
      </div>
      <div className="bg-black/60 border border-slate-800 rounded-md p-3 h-44 overflow-y-auto font-mono text-[11px] space-y-1" data-testid="live-test-log">
        {!data?.logs?.length && <p className="text-slate-600">No messages yet. Attach the EA to a chart. Its messages appear here within a few seconds.</p>}
        {data?.logs?.map((l, i) => (
          <div key={i} className={`whitespace-pre-wrap break-words ${l.kind === "pasted" ? "text-cyan-300" : LEVEL[l.level]}`}>
            <span className="text-slate-600">{fmtUtc(l.created_at).slice(5)} </span>
            {l.kind === "pasted" ? "[Experts tab] " : l.level === "warning" ? "⚠ " : ""}{l.message}
          </div>
        ))}
      </div>
      <Textarea value={paste} onChange={(e) => setPaste(e.target.value)} rows={3} data-testid="experts-paste-input"
        placeholder="Paste what MetaTrader's Terminal › Experts tab shows (right-click › Copy) to share it here" className="font-mono text-xs" />
      <Button onClick={save} disabled={!paste.trim()} size="sm" variant="outline" className="border-slate-700" data-testid="experts-paste-save">Share Experts tab log</Button>
    </div>
  );
};
